/**
 * **The print log** (Stream A, James Oct 18): every Paper-family sheet, once its figures are in,
 * goes on the log with who printed it and when — a person through their own door, the admin
 * station in the name of whoever is at the desk. What was on the sheet is never logged.
 */
import { useEffect, useRef } from 'react';
import { api } from '../shell/api.js';

export function usePrinted(
  sheet: string,
  ready: boolean,
  opts: { ref?: string | null; year?: number | null; station?: boolean } = {},
): void {
  const done = useRef(false);
  useEffect(() => {
    if (!ready || done.current) return;
    done.current = true;
    const path = opts.station ? '/volunteers/booth/printed' : '/print/printed';
    const body = opts.station
      ? { sheet }
      : { sheet, ref: opts.ref ?? null, ...(opts.year ? { year: opts.year } : {}) };
    api('POST', path, body).catch(() => undefined);
  }, [ready, sheet, opts.ref, opts.year, opts.station]);
}
